import React, { useContext } from 'react';
import { Modal } from '@fluentui/react'
import { CUSTOM_STYLES } from '../../constants/Constants';
import themeContext from '../../context/theme/ThemeContext';

const ModalMain = (props) => {

  const isViewer = false;
  const Containerstyles=  {
    root:{
      backgroundColor: 'rgba(0, 0, 0, 0.75);',
   },
    main:{
      boxSizing: "border-box",
      borderRadius: "10px 10px 10px 10px",
      fontFamily: "Open Sans",
      fontStyle: "normal",
      boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.90)",
      border: CUSTOM_STYLES.MODAL_BORDER,
      width:props.modalDetails.width,
      minHeight: '150px'
    },
  }

  const {getThemeColor} = useContext(themeContext)
  
  return (
    <div>
      <Modal styles={props.styles != undefined? props.styles:Containerstyles}
      className='main'
        titleAriaId="id"
        isOpen={props.showModal}
        allowTouchBodyScroll={true}
      >
        {props.modalDetails.header}
        <div className='modal-body' style={{background: !isViewer ? getThemeColor("modal-body") : "#191919", color:getThemeColor("primary-color")}}>{props.modalDetails.body}</div>
        {props.modalDetails.footer}
      </Modal>
    </div>
  )
}

export default ModalMain